export enum ESaleRequestFilterParams {
  CULTURES = 'cultures',
  REGION_CODES = 'regionCodes',
  STATUSES = 'statuses',
  AGRARIANS = 'agrarians',
  AGRARIANS_NAME = 'agrariansName',
  BUYERS = 'buyers',
  BUYER_NAME = 'buyerName',
  REQUEST_ID = 'requestId',
}
